'use client';

import React, { memo, useMemo } from 'react';


interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  variant?: 'full' | 'emblem';
}

const AppLogo = memo(function AppLogo({
  size = 64,
  className = '',
  onClick,
  variant = 'full',
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  if (variant === 'emblem') {
    return (
      <div className={containerClassName} onClick={onClick} style={{ flexShrink: 0 }}>
        <img
          src="/assets/images/BetProtect_Icon_Blue-1787333219945.png"
          alt="BetProtect"
          style={{ width: size, height: size, objectFit: 'contain' }}
        />
      </div>
    );
  }

  // full variant — primary wordmark logo
  return (
    <div className={containerClassName} onClick={onClick}>
      <img
        src="/assets/images/BetProtect_Primary_Logo-1787333220198.png"
        alt="BetProtect"
        style={{ width: size, height: 'auto', objectFit: 'contain', flexShrink: 0 }}
      />
    </div>
  );
});

export default AppLogo;
